import { type SupplierListItem } from '@choco-admin/types';
import React from 'react';

import { AlertCard } from '../../../../../../components/AlertCard';
import { FeatureFlagControlTable } from '../../../../../../components/FeatureFlagControl';
import { ORDER_AGENT_FLAG_TAG } from '../OrderAgentTab/OrderAgentFeatureFlags';

const SUPPLIER_FLAG_TAGS = ['supplier'];
// Order Agent flags are listed on the Order Agent tab instead.
const EXCLUDED_FLAG_TAGS = [ORDER_AGENT_FLAG_TAG];

interface FeatureFlagsTabProps {
  supplier?: SupplierListItem;
}

export const FeatureFlagsTab: React.FC<FeatureFlagsTabProps> = ({
  supplier,
}) => {
  if (!supplier) {
    return (
      <AlertCard
        type="info"
        title="Create distributor first"
        message="Please save the distributor to manage its feature flags."
      />
    );
  }

  return (
    <FeatureFlagControlTable
      entity={{ kind: 'supplier', id: supplier.id }}
      entityName={supplier.name ?? undefined}
      tags={SUPPLIER_FLAG_TAGS}
      excludeTags={EXCLUDED_FLAG_TAGS}
    />
  );
};
